import { Theme } from '@eversports/react-components/design-tokens/theme'
import SubscribeToNewsletterBanner from '@eversports/react-components/patterns/SubscribeToNewsletterBanner'
import { makeStyles } from '@mui/styles'
import React from 'react'
import useAmplitude from '@eversports/amplitude-react/useAmplitude'

import useMutationWithErrorHandling from '../../data/useMutationWithErrorHandling'
import Venue from '../../typings/Venue'

import {
  NewsletterBannerSubscribeToNewsletterMutation,
  NewsletterBannerSubscribeToNewsletterMutationVariables,
  NewsletterBannerSubscribeToNewsletterDocument,
} from '../../graphql'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    margin: `${theme.layoutSpacing.default} 0`,
    padding: `0 ${theme.layoutSpacing.wide}`,
  },
}))

interface Props {
  venue: Venue
  customerId: string
}

const NewsletterBanner: React.FC<React.PropsWithChildren<Props>> = ({ venue, customerId }) => {
  const classes = useStyles()
  const { amplitude } = useAmplitude()

  const [subscribeToNewsletter] = useMutationWithErrorHandling<
    NewsletterBannerSubscribeToNewsletterMutation,
    NewsletterBannerSubscribeToNewsletterMutationVariables
  >(NewsletterBannerSubscribeToNewsletterDocument, { variables: { customerId } })

  const onButtonClick = () => {
    if (amplitude) {
      amplitude.logEvent('Subscribed to Venue Newsletter', {
        venue: {
          name: venue.name,
        },
        where: 'confirmation page',
      })
    }

    // eslint-disable-next-line  @typescript-eslint/no-floating-promises
    subscribeToNewsletter()
  }

  return (
    <div className={classes.container}>
      <SubscribeToNewsletterBanner
        onButtonClick={onButtonClick}
        venueName={venue.name}
        venueImage={venue.logo && venue.logo.large}
      />
    </div>
  )
}

export default NewsletterBanner
